import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App, { appConfig } from "./App";
import { CircularProgress} from "@material-ui/core";
import "./i18n";
import * as serviceWorker from "./serviceWorker";
import { Auth0Provider } from '@auth0/auth0-react';
import store from "redux/Store";
import { Provider } from "react-redux";

const onRedirectCallback = (appState, user) => {
  // Check if appState contains a returnTo value
  window.history.replaceState(
      {},
      document.title,
      appState && appState.returnTo ? appState.returnTo : window.location.pathname
  );
};

const urlSearchParams = new URLSearchParams(window.location.search);
const queryParams = Object.fromEntries(urlSearchParams.entries());

let authorizationParams = {
  redirect_uri: window.location.origin, 
  audience: appConfig.AUTH0_AUDIENCE, 
  scope: "openid profile email", 
  ...(queryParams.organization ? { organization: queryParams.organization } : {}), 
  ...(queryParams.login_hint ? { login_hint: queryParams.login_hint } : {}), 
  ...(queryParams.invitation ? { invitation: queryParams.invitation } : {}), 
  ...(queryParams.connection ? { connection: queryParams.connection } : {}), 
  ...(queryParams.screen_hint ? { screen_hint: queryParams.screen_hint } : {}), 
}

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={<div className="loader"><CircularProgress  /></div>}>
      {console.log('>>>appConfig.AUTH0_DOMAIN', appConfig.AUTH0_DOMAIN)}
      <Auth0Provider
          domain={appConfig.AUTH0_DOMAIN}
          clientId={appConfig.AUTH0_SPA_CLIENT_ID}
          authorizationParams={authorizationParams}
          cacheLocation={"localstorage"}
          useRefreshTokens={true}
          useCookiesForTransactions={true}
          useRefreshTokensFallback={false}
          cookieDomain={appConfig.AUTH0_COOKIE_DOMAIN}
          onRedirectCallback={onRedirectCallback}
      >
        <App />
      </Auth0Provider>
    </Suspense>
  </Provider>, 
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
